import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth-guard';
import { adminGuard } from './core/guards/admin-guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'trocar-senha',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent,
      ),
  },
  {
    path: '',
    redirectTo: 'beneficiarios',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'beneficiarios',
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-list/beneficiary-list.component'
          ).then((m) => m.BeneficiaryListComponent),
      },
      {
        path: 'beneficiarios/:id/atender',
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-form/beneficiary-form.component'
          ).then((m) => m.BeneficiaryFormComponent),
      },
      {
        path: 'atendimentos',
        loadComponent: () =>
          import(
            './features/attendances/pages/attendance-list/attendance-list.component'
          ).then((m) => m.AttendanceListComponent),
      },
      {
        path: 'carregamento',
        loadComponent: () =>
          import(
            './features/beneficiario/pages/upload-home/upload-home.component'
          ).then((m) => m.UploadHomeComponent),
      },
      {
        path: 'carregamento/matriz',
        data: { uploadMode: 'matrix' },
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-upload/beneficiary-upload.component'
          ).then((m) => m.BeneficiaryUploadComponent),
      },
      {
        path: 'carregamento/atendimentos-advcare',
        data: { uploadMode: 'attendance' },
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-upload/beneficiary-upload.component'
          ).then((m) => m.BeneficiaryUploadComponent),
      },
      {
        path: 'carregamento/despesas-grupo',
        data: { uploadMode: 'expense' },
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-upload/beneficiary-upload.component'
          ).then((m) => m.BeneficiaryUploadComponent),
      },
      {
        path: 'carregamento/extrato-beneficiario',
        data: { uploadMode: 'statement' },
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-upload/beneficiary-upload.component'
          ).then((m) => m.BeneficiaryUploadComponent),
      },
      {
        path: 'carregamento/monitoramento',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiary-monitoring/beneficiary-monitoring.component'
          ).then((m) => m.BeneficiaryMonitoringComponent),
      },
      {
        path: 'beneficiario/monitoramentografico',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './features/beneficiario/pages/beneficiario-monitoramento-grafico/beneficiario-monitoramento-grafico.component'
          ).then((m) => m.BeneficiarioMonitoramentoGraficoComponent),
      },
      {
        path: 'monitoramento/quantitativo',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './features/beneficiario/pages/monitoramento-quantitativo/monitoramento-quantitativo.component'
          ).then((m) => m.MonitoramentoQuantitativoComponent),
      },
      {
        path: 'monitoramento/quantitativo-atualizado',
        canActivate: [adminGuard],
        data: { updatedQuantitative: true },
        loadComponent: () =>
          import(
            './features/beneficiario/pages/monitoramento-quantitativo/monitoramento-quantitativo.component'
          ).then((m) => m.MonitoramentoQuantitativoComponent),
      },
      {
        path: 'monitoramento/impacto-custos',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './features/beneficiario/pages/monitoramento-impacto-custos/monitoramento-impacto-custos.component'
          ).then((m) => m.MonitoramentoImpactoCustosComponent),
      },
      {
        path: 'monitoramento_resposta',
        canActivate: [adminGuard],
        loadComponent: () =>
          import(
            './features/beneficiario/pages/monitoramento-respostas-risco/monitoramento-respostas-risco.component'
          ).then((m) => m.MonitoramentoRespostasRiscoComponent),
      },
      {
        path: 'carregamento/outro',
        redirectTo: '/carregamento/atendimentos-advcare',
      },
      {
        path: 'atendimentos/:beneficiaryId/documentos',
        loadComponent: () =>
          import(
            './features/attendances/pages/attendance-documents/attendance-documents.component'
          ).then((m) => m.AttendanceDocumentsComponent),
      },
      {
        path: 'admin/usuarios',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/pages/user-management/user-management.component').then(
            (m) => m.UserManagementComponent,
          ),
      },
      {
        path: 'admin/documentos',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/pages/document-management/document-management.component').then(
            (m) => m.DocumentManagementComponent,
          ),
      },
      {
        path: 'admin/perguntas',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/pages/question-management/question-management.component').then(
            (m) => m.QuestionManagementComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'beneficiarios',
  },
];



